export default __webpack_public_path__ + "static/licence-open-a187f77ef7c3c10ebf9589ea5327b6d3.png";